import { useState, useEffect } from "react"
import { ArrowDownTrayIcon } from "@heroicons/react/20/solid"
import { Modal } from "./Modal"

export const InstallButton = () => {
  const [supportsPWA, setSupportsPWA] = useState(false)
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null)
  const [modalOpen, setModalOpen] = useState<boolean>(false)

  useEffect(() => {
    window.addEventListener("beforeinstallprompt", (e) => {
      e.preventDefault()
      setSupportsPWA(true)
      setDeferredPrompt(e)
    })
  }, [])

  const install = async () => {
    if (deferredPrompt !== null) {
      deferredPrompt.prompt()
      const { outcome } = await deferredPrompt.userChoice

      if (outcome === "accepted") {
        setDeferredPrompt(null)
      }
    }
  }

  return supportsPWA ? (
    <>
      <button
        onClick={() => (supportsPWA ? install() : setModalOpen(true))}
        className="bg-brand-light text-white w-8 h-8 flex items-center justify-center rounded"
        type="button"
      >
        <ArrowDownTrayIcon className="h-5 w-5" />
      </button>
      <Modal open={modalOpen} setOpen={setModalOpen}>
        <div>
          Your browser does not support native PWA installation.
          <br />
          <br />
          Please check your browser settings for a possible installation option,
          or try another browser.
        </div>
        <div className="mt-5 sm:mt-6">
          <button
            type="button"
            className="inline-flex w-full justify-center rounded-md border border-transparent bg-brand-light px-4 py-2 text-base font-medium text-white shadow-sm sm:text-sm"
            onClick={() => setModalOpen(false)}
          >
            OKAY
          </button>
        </div>
      </Modal>
    </>
  ) : (
    <div />
  )
}
